function AuthService($firebaseAuth) {
  var auth = $firebaseAuth();
  var authData = null;
  function storeAuthData(response) {
    authData = response;
    ChurnZero.push(['setContact', 'acct-'+authData.uid, authData.uid]);
    return authData;
  }
  function onSignIn(user) {
    authData = user;
    ChurnZero.push(['setContact', 'acct-'+authData.uid, authData.uid]);
    return auth.$requireSignIn();
  }
  function clearAuthData() {
    authData = null;
    ChurnZero.push(['stop']);
  }
  this.login = function (user) {
    return auth
      .$signInWithEmailAndPassword(user.email, user.password)
      .then(storeAuthData);
  };
  this.register = function (user) {
    return auth
      .$createUserWithEmailAndPassword(user.email, user.password)
      .then(storeAuthData);
  };
  this.logout = function () {
    return auth
      .$signOut()
      .then(clearAuthData);
  };
  this.requireAuthentication = function () {
    return auth
      .$waitForSignIn().then(onSignIn);
  };
  this.isAuthenticated = function () {
    return !!authData;
  };
  this.getUser = function () {
    if (authData) {
      return authData;
    }
  };
}

angular
  .module('components.auth')
  .service('AuthService', AuthService);
